import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  @media ${until(Device.TabletLarge)} {
    background: ${brand.primary.grey.light};
  }
`;
const Title = styled.button `
  @media ${until(Device.TabletLarge)} {
    ${fonts.inter.extraBold};

    display: flex;
    align-items: center;
    background: ${brand.primary.grey.light};
    border: 0;
    color: ${brand.black};
    font-size: 16px;
    line-height: 18px;
    height: 60px;
    margin: 0;
    padding: 15px 20px 18px;
    text-transform: uppercase;
    width: 100%;

    svg {
      display: block;
      height: 13px;
      margin-left: auto;
      transform: rotate(0deg);
      transform-origin: center;
      transition: transform 0.15s ease-out;
      width: 13px;
    }

    [data-open='true'] & {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const Content = styled.div `
  @media ${until(Device.TabletLarge)} {
    height: 0;
    overflow: hidden;

    [data-open='true'] & {
      height: auto;
    }
  }
`;
const Inner = styled.div `
  @media ${until(Device.TabletLarge)} {
    padding: 15px 20px 24px;
  }
`;
const ToggleBlockStyles = {
    Container,
    Title,
    Content,
    Inner,
};
export default ToggleBlockStyles;
